import { BHASHINI_SOCKET_API_KEY, BHASHINI_ENDPOINT_URL, BHASHINI_SOCKET_URL, VAD_MODEL_URL, VAD_WORKLET_URL } from "../../utils/constants";
import React, { forwardRef, useRef, useState, useEffect, useImperativeHandle, useMemo } from "react";
// import { useSelector, useDispatch } from "react-redux";
import { Mic, Loader2, Waves, AlertCircle, Globe } from "lucide-react";
import { useMicVAD } from "@ricky0123/vad-react";
import { getDefaultRealTimeVADOptions } from "@ricky0123/vad-web";
import { io } from "socket.io-client";
import { motion, AnimatePresence } from "framer-motion";
// import { useAppContext } from "../../../context/AppContext";
// import useLocalization from '../../../hooks/useLocalization';
import PropTypes from 'prop-types';
import axios from "axios";
import "./index.css"


import micIcon from "../../assets/images/mic.png";
import voiceAssistantGif from "../../assets/images/voice_assis.gif";
import {
    detectBrowser,
    applyBrowserFixes,
    getOptimizedSettings,
    getRequiredWorkarounds,
    validateBrowserCompatibility
} from "./browserUtils";
import { t } from "i18next";
import TooltipBubble from "./TooltipBubble";
import { LANGUAGES } from "../commonComponent/LanguageModel/LanguageModal";

const BROWSER_TYPE = detectBrowser();
const BROWSER_SETTINGS = getOptimizedSettings();
const BROWSER_WORKAROUNDS = getRequiredWorkarounds();

const SAMPLE_RATE = 16000;
const SILENCE_TIMEOUT = BROWSER_SETTINGS.timing.silenceTimeout;
const POST_SILENCE_GRACE_PERIOD = BROWSER_SETTINGS.timing.postSilenceGracePeriod;
const MAX_BUFFER_SIZE = BROWSER_SETTINGS.buffers.maxBufferSize;
const ALD_RETRY_ATTEMPTS = 2;
const SILENCE_TIMEOUT_MS = 5000;
// import { useLogger } from "../../../utils/UnifiedLogger";
// import {
//     selectIsTextLanguageDetecting,
//     selectIsContentGenerating,
//     selectIsNerDetecting,
//     selectDisplayTranscript,
//     selectTranscriptType,
//     selectAccumulatedFinalTranscript,
//     selectCurrentInterimTranscript,
//     selectSelectedSocketLanguageData,
//     selectIsSocketRecording,
// } from "../../../store/features/message/textContentSelectors";

// import {
//     setSocketFlags,
//     setDisplayTranscript,
//     setIsSocketRecording,
//     setSelectedSocketLanguageData,
//     setTranscriptType,
//     setAccumulatedFinalTranscript,
//     setCurrentInterimTranscript,
//     setRecordedBase64Data
// } from "../../../store/features/message/textContentSlice";

// import { getLanguageData } from "../../../utils/AppConstants";
// import { updateFlowStates } from "../../../store/features/message/updateFlowStates";
// import { setIsMicButtonClicked } from "../../../store/features/ui/uiSlice";
// import TooltipBubble from "../Tooltip/TooltipBubble";
// import { selectMicButtonDisabled } from "../../../store/features/ui/uiSelectors";

const bars = [
    { height: "h-1", delay: 0 },
    { height: "h-2", delay: 0.2 },
    { height: "h-1", delay: 0.4 },
    { height: "h-2", delay: 0.5 },
    { height: "h-1", delay: 0.6 },
];

export const getLanguageData = (code) =>
    LANGUAGES.find((lang) => lang.code === code) || null;


const SocketMicStreamer = forwardRef(({
    isUserInputBar = false,
    currentText,
    completedText,
    language,
    micClicked,
    isMicButtonDisabled,
    onAudioRecorded
}, ref) => {
    // const { logInfo } = useLogger("SocketMicStreamer", false);
    // const dispatch = useDispatch();
    // const { sharedApiService } = useAppContext();
    const aldRequestIdRef = useRef(null);
    const [getLanguage, setLanguage] = useState();
    const [displayTranscript, setDisplayTranscript] = useState();
    const [transcriptType, setTranscriptType] = useState();
    const [accumulatedFinalTranscript, setAccumulatedFinalTranscript] = useState();
    const [currentInterimTranscript, setCurrentInterimTranscript] = useState();
    const [selectedSocketLanguageData, setSelectedSocketLanguageData] = useState();
    const [getIsSocketRecording, setIsSocketRecording] = useState();
    const [isLanguageDetecting, setIsTextLanguageDetecting] = useState();
    const [isContentGenerating, setIsContentGenerating] = useState();
    const [isNerDetecting, setIsNerDetecting] = useState();
    // const [isMicButtonDisabled, setMicButtonDisabled] = useState();
    const [isMicButtonClicked, setIsMicButtonClicked] = useState(false);
    const [recordedBase64Data, setRecordedBase64Data] = useState();
    // const [streamingFlag, setStreamingFlag] = useState(false);
    // const [flags, setFlags] = useState({});

    // const { t, setLanguage } = useLocalization();

    // const displayTranscript = useSelector(selectDisplayTranscript);
    // const transcriptType = useSelector(selectTranscriptType);
    // const accumulatedFinalTranscript = useSelector(selectAccumulatedFinalTranscript);
    // const currentInterimTranscript = useSelector(selectCurrentInterimTranscript);
    // const selectedSocketLanguageData = useSelector(selectSelectedSocketLanguageData);
    // const getIsSocketRecording = useSelector(selectIsSocketRecording);
    // const isLanguageDetecting = useSelector(selectIsTextLanguageDetecting);
    // const isContentGenerating = useSelector(selectIsContentGenerating);
    // const isNerDetecting = useSelector(selectIsNerDetecting);
    // const isMicButtonDisabled = useSelector(selectMicButtonDisabled);


    const accumulatedTranscriptRef = useRef("");
    const aldAudioBufferRef = useRef([]);
    const aldInProgressRef = useRef(false);
    const aldRetryCountRef = useRef(0);
    const audioChunksRef = useRef([]);
    const audioContextRef = useRef(null);
    const audioQualityBufferRef = useRef([]);
    const completeAudioBufferRef = useRef([]);
    const continuousSpeechDurationRef = useRef(0);
    const gracePeriodTimeoutRef = useRef(null);
    const hasDetectedLanguageRef = useRef(false);
    const isProcessingFinalAudioRef = useRef(false);
    const isSilenceProcessingRef = useRef(false);
    const isSocketInitializingRef = useRef(false);
    const isSocketReadyRef = useRef(false);
    const isUserSpeaking = useRef(false);
    const lastALDAttemptRef = useRef(0);
    const lastFinalTranscriptRef = useRef("");
    const mediaStreamRef = useRef(null);
    const postAldAudioBufferRef = useRef([]);
    const processorNodeRef = useRef(null);
    const sendIntervalRef = useRef(null);
    const silenceTimeoutRef = useRef(null);
    const socketInitPromiseRef = useRef(null);
    const socketRef = useRef(null);
    const sourceNodeRef = useRef(null);
    const speechStartTimeRef = useRef(null);
    const totalAudioDurationRef = useRef(0);
    const transcriptRef = useRef(null);
    const silenceTimerRef = useRef(null);
    const lastSoundTimeRef = useRef(Date.now());


    const [isLoading, setIsLoading] = useState(false);
    const [isSocketErr, setIsSocketError] = useState(false);

    const [flags, setFlags] = useState({
        aldProcessingTime: 0,
        aldRetryCount: 0,
        audioLength: 0,
        audioQuality: 'good',
        browserCompatible: true,
        browserType: BROWSER_TYPE,
        bufferStatus: 'empty',
        detectedLanguage: '',
        detectingLanguage: false,
        error: null,
        initializing: false,
        languageDetected: false,
        listening: false,
        processing: false,
        socketConnecting: false,
        socketReady: false,
        streaming: false,
    });

    const apiKey = BHASHINI_SOCKET_API_KEY;
    // Using iitmandi model — best accuracy for 12 Indian languages (hi, en, ta, te, kn, ml, gu, mr, bn, pa, or, as)
    const ALD_SERVICE_ID = "bhashini/iitmandi/audio-lang-detection/gpu";
    const LANG_DETECTION_ENDPOINT_URL = BHASHINI_ENDPOINT_URL;
    const serverUrl = BHASHINI_SOCKET_URL;
    const socketType = "asrasa";

    const logInfo = (tag, message, data = {}) => {
        console.log(`[${tag}] ${message}`, data);
    };



    useEffect(() => {
        accumulatedTranscriptRef.current = accumulatedFinalTranscript;
        completedText(accumulatedFinalTranscript);
    }, [accumulatedFinalTranscript]);

    const hasPushedCurrentTextRef = useRef(false);
    const silenceDeadlineRef = useRef(null);


    useEffect(() => {
        if (!currentInterimTranscript) return;
        currentText(currentInterimTranscript);
        hasPushedCurrentTextRef.current = true;
    }, [currentInterimTranscript]);

    useEffect(() => {
        language(getLanguage);
    }, [getLanguage]);

    useEffect(() => {
        micClicked(isMicButtonClicked);
    }, [isMicButtonClicked]);

    // useEffect(() => {
    //     console.log("Streaming Ended Flag:", streamingFlag);
    //     streamingended(streamingFlag);
    //     console.log("Streaming Ended Function Called", streamingFlag);
    // }, [streamingFlag]);


    useEffect(() => {
        if (transcriptRef.current) {
            transcriptRef.current.scrollTop = transcriptRef.current.scrollHeight;
        }
    }, [accumulatedFinalTranscript, currentInterimTranscript]);


    useEffect(() => {
        const initializeBrowser = () => {
            try {
                applyBrowserFixes();
                const compatibility = validateBrowserCompatibility();
                updateFlags({
                    browserType: BROWSER_TYPE,
                    browserCompatible: compatibility.compatible
                });

                if (!compatibility.compatible) {
                    updateFlags({
                        error: `Browser compatibility issues: ${compatibility.issues.join(', ')}`
                    });
                    logInfo("BROWSER_ERROR", "Compatibility issues detected", compatibility);
                } else {
                    logInfo("BROWSER_INIT", "Browser initialized successfully", {
                        browser: BROWSER_TYPE,
                        settings: BROWSER_SETTINGS,
                        workarounds: BROWSER_WORKAROUNDS
                    });
                }
                if (compatibility.warnings.length > 0) {
                    compatibility.warnings.forEach(warning => {
                        logInfo("BROWSER_WARNING", warning);
                    });
                }
            } catch (error) {
                logInfo("BROWSER_INIT_ERROR", error.message);
                updateFlags({
                    error: `Browser initialization failed: ${error.message}`,
                    browserCompatible: false
                });
            }
        };
        initializeBrowser();
    }, []);

    const updateFlags = (newFlags) => {
        setFlags(prev => {
            const updated = { ...prev, ...newFlags };
            return updated;
        });
    };

    // useEffect(() => {
    //     dispatch(setSocketFlags(flags));
    // }, [flags, setSocketFlags]);

    const isLanguageExist = () => {
        return (
            selectedSocketLanguageData &&
            typeof selectedSocketLanguageData === "object" &&
            Object.keys(selectedSocketLanguageData).length > 0 &&
            selectedSocketLanguageData.code?.trim()
        );
    };

    const getLanguageCode = () => {
        return isLanguageExist() ? selectedSocketLanguageData.code : 'en';
    };

    const assessAudioQuality = (audioChunks) => {
        if (!audioChunks || audioChunks.length === 0) {
            return { quality: 'poor', reason: 'No audio data', rms: 0, dynamicRange: 0 };
        }

        try {
            const totalLength = audioChunks.reduce((acc, chunk) => acc + chunk.length, 0);
            const combined = new Float32Array(totalLength);

            let offset = 0;
            for (const chunk of audioChunks) {
                if (chunk && chunk.length) {
                    combined.set(chunk, offset);
                    offset += chunk.length;
                }
            }

            if (combined.length === 0) {
                return { quality: 'poor', reason: 'Empty combined audio', rms: 0, dynamicRange: 0 };
            }

            const rms = Math.sqrt(combined.reduce((sum, sample) => sum + sample * sample, 0) / combined.length);

            let max = -Infinity;
            let min = Infinity;

            for (const value of combined) {
                if (value > max) max = value;
                if (value < min) min = value;
            }

            const dynamicRange = max - min;
            const duration = combined.length / SAMPLE_RATE;

            let quality = 'good';
            let reason = 'Audio quality acceptable';

            if (rms < 0.001) {
                quality = 'poor';
                reason = 'Audio too quiet (RMS < 0.001)';
            } else if (rms > 0.8) {
                quality = 'poor';
                reason = 'Audio too loud/clipped (RMS > 0.8)';
            } else if (dynamicRange < 0.01) {
                quality = 'poor';
                reason = 'Audio too flat (no dynamic range)';
            } else if (duration < 0.5) {
                quality = 'poor';
                reason = `Audio too short (${duration.toFixed(1)}s < 0.5s)`;
            } else if (rms < 0.005) {
                quality = 'fair';
                reason = 'Audio quiet but acceptable';
            } else if (duration < 1.0) {
                quality = 'fair';
                reason = 'Audio short but acceptable';
            }

            return { quality, reason, rms, dynamicRange, duration };
        } catch (error) {
            logInfo("AUDIO_QUALITY_ERROR", error.message);
            return { quality: 'poor', reason: 'Quality assessment failed', rms: 0, dynamicRange: 0 };
        }
    };

    const convertAudioData = (audioData) => {
        if (!audioData || audioData.length === 0) {
            logInfo("CONVERT_AUDIO_WARNING", "Empty audio data provided");
            return [];
        }

        try {
            return Array.from(new Int16Array(audioData.map(s => {
                const clampedSample = Math.max(-1, Math.min(1, s));
                return clampedSample < 0 ? clampedSample * 0x8000 : clampedSample * 0x7fff;
            })));
        } catch (error) {
            logInfo("CONVERT_AUDIO_ERROR", error.message);
            return [];
        }
    };

    const getCombinedAudioBase64 = async (chunks) => {
        try {
            if (!chunks || chunks.length === 0) {
                throw new Error("No audio chunks provided");
            }

            const validChunks = chunks.filter(chunk =>
                chunk && chunk.length > 0 && chunk instanceof Float32Array
            );

            if (validChunks.length === 0) {
                throw new Error("No valid audio chunks found");
            }

            const totalLength = validChunks.reduce((acc, chunk) => acc + chunk.length, 0);
            if (totalLength === 0) {
                throw new Error("Total audio length is zero");
            }

            const combined = new Float32Array(totalLength);
            let offset = 0;

            for (const chunk of validChunks) {
                combined.set(chunk, offset);
                offset += chunk.length;
            }

            const qualityAssessment = assessAudioQuality([combined]);
            updateFlags({ audioQuality: qualityAssessment.quality });

            const buffer = new ArrayBuffer(44 + combined.length * 2);
            const view = new DataView(buffer);

            const writeString = (offset, str) => {
                for (let i = 0; i < str.length; i++) {
                    view.setUint8(offset + i, str.charCodeAt(i));
                }
            };

            writeString(0, 'RIFF');
            view.setUint32(4, 36 + combined.length * 2, true);
            writeString(8, 'WAVE');
            writeString(12, 'fmt ');
            view.setUint32(16, 16, true);
            view.setUint16(20, 1, true);
            view.setUint16(22, 1, true);
            view.setUint32(24, SAMPLE_RATE, true);
            view.setUint32(28, SAMPLE_RATE * 2, true);
            view.setUint16(32, 2, true);
            view.setUint16(34, 16, true);
            writeString(36, 'data');
            view.setUint32(40, combined.length * 2, true);

            for (let i = 0; i < combined.length; i++) {
                let sample = combined[i];
                if (Math.abs(sample) > 1.0) {
                    sample = sample / Math.abs(sample);
                }
                const intSample = sample < 0 ? sample * 0x8000 : sample * 0x7fff;
                view.setInt16(44 + i * 2, Math.round(intSample), true);
            }

            return new Promise((resolve, reject) => {
                try {
                    const blob = new Blob([buffer], { type: 'audio/wav' });
                    if (blob.size === 0) {
                        reject(new Error("Generated blob is empty"));
                        return;
                    }

                    const reader = new FileReader();
                    reader.onloadend = () => {
                        try {
                            const result = reader.result;
                            if (!result || typeof result !== 'string') {
                                reject(new Error("FileReader result is invalid"));
                                return;
                            }

                            const base64 = result.split(',')[1];
                            if (!base64 || base64.length === 0) {
                                reject(new Error("Base64 conversion failed"));
                                return;
                            }
                            resolve(base64);
                        } catch (error) {
                            reject(new Error(`FileReader processing failed: ${error.message}`));
                        }
                    };

                    reader.onerror = () => {
                        reject(new Error(`FileReader error: ${reader.error?.message || 'Unknown error'}`));
                    };

                    reader.readAsDataURL(blob);
                } catch (error) {
                    reject(new Error(`Blob creation failed: ${error.message}`));
                }
            });
        } catch (error) {
            logInfo("AUDIO_CONVERSION_ERROR", `Conversion failed: ${error.message}`);
            throw new Error(`Audio conversion failed: ${error.message}`);
        }
    };


    async function sendAldRequestAxios({
        requestBody,
        apiKey,
        reason,
        audioLengthSec,
        startTime
    }) {
        const controller = new AbortController();
        const requestId = crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).substring(2) + Date.now().toString(36);

        let attempt = 0;
        let lastError = null;

        const metrics = {
            attempts: 0,
            duration: 0,
            status: null
        };

        try {
            // ---- onStart ----
            aldRequestIdRef.current = requestId;
            logInfo("ALD_START", `Starting language detection - Reason: ${reason}`, {
                requestId,
                attempt: 1,
                maxAttempts: ALD_RETRY_ATTEMPTS + 1
            });

            while (attempt <= ALD_RETRY_ATTEMPTS) {
                const attemptStart = Date.now();
                metrics.attempts = attempt + 1;

                try {
                    const response = await axios({
                        method: "POST",
                        url: LANG_DETECTION_ENDPOINT_URL,
                        headers: {
                            "Authorization": apiKey,
                            "Content-Type": "application/json"
                        },
                        data: requestBody,
                        timeout: 30000,
                        signal: controller.signal
                    });

                    metrics.duration = Date.now() - startTime;
                    metrics.status = response.status;

                    // ---- onSuccess ----
                    logInfo("ALD_SUCCESS", "Language detection API call successful", {
                        duration: metrics.duration,
                        attempts: metrics.attempts
                    });

                    // ---- onComplete ----
                    logInfo("ALD_COMPLETE", "Request completed", { requestId });
                    aldRequestIdRef.current = null;

                    return {
                        data: response.data,
                        error: null,
                        metrics
                    };

                } catch (err) {
                    lastError = err;
                    metrics.status = err.response?.status ?? "NETWORK_ERROR";

                    // ---- onError ----
                    logInfo("ALD_ERROR", `API call failed: ${err.message}`, {
                        status: metrics.status,
                        duration: Date.now() - attemptStart,
                        attempts: metrics.attempts
                    });

                    if (attempt >= ALD_RETRY_ATTEMPTS) break;

                    attempt++;

                    const retryDelay = 1000 * attempt;

                    // ---- onRetry ----
                    aldRetryCountRef.current = attempt;
                    updateFlags({
                        aldRetryCount: attempt,
                        error: `ALD retry ${attempt}/${ALD_RETRY_ATTEMPTS}`
                    });

                    logInfo("ALD_RETRY", "Retrying language detection", {
                        attempt,
                        maxRetries: ALD_RETRY_ATTEMPTS,
                        retryDelay: `${retryDelay}ms`
                    });

                    await new Promise(res => setTimeout(res, retryDelay));
                }
            }

            throw lastError;

        } finally {
            aldRequestIdRef.current = null;
        }
    }


    const detectLanguage = async (audioChunks, reason = "UNKNOWN") => {
        if (aldInProgressRef.current || hasDetectedLanguageRef.current || isLanguageExist()) {
            logInfo("ALD", "Skipping - already in progress, completed, or predefined language exists");
            return getLanguageCode();
        }

        const now = Date.now();
        if (now - lastALDAttemptRef.current < 1000) {
            logInfo("ALD", "Skipping - too soon since last attempt");
            return getLanguageCode();
        }
        lastALDAttemptRef.current = now;
        const startTime = Date.now();

        try {
            aldInProgressRef.current = true;

            updateFlags({
                detectingLanguage: true,
                processing: true,
                aldRetryCount: aldRetryCountRef.current
            });

            if (!audioChunks || audioChunks.length === 0) {
                throw new Error("No audio chunks provided for ALD");
            }

            const qualityAssessment = assessAudioQuality(audioChunks);
            // Require at least 1.5s of speech — shorter audio leads to ALD misidentification
            if (qualityAssessment.quality === 'poor' && aldRetryCountRef.current === 0 && qualityAssessment.duration < 1.5) {
                if (getIsSocketRecording && continuousSpeechDurationRef.current < 2000) {
                    aldInProgressRef.current = false;
                    throw new Error(`Audio quality insufficient: ${qualityAssessment.reason}`);
                }
            }

            const base64Audio = await getCombinedAudioBase64(audioChunks);
            if (!base64Audio || base64Audio.length === 0) {
                throw new Error("Audio conversion resulted in empty base64");
            }

            const audioLengthSec = audioChunks.reduce((acc, chunk) => acc + chunk.length, 0) / SAMPLE_RATE;
            updateFlags({ audioLength: audioLengthSec.toFixed(1) });

            const requestBody = {
                pipelineTasks: [{
                    taskType: "audio-lang-detection",
                    config: {
                        serviceId: ALD_SERVICE_ID,
                        preprocessors: ["audio_enhancement"],
                        language: { targetLanguage: "auto" }
                    }
                }],
                inputData: {
                    audio: [{
                        audioContent: base64Audio,
                        audioFormat: "wav",
                        samplingRate: SAMPLE_RATE,
                        channels: 1
                    }]
                }
            };

            // Use the sendRequest method from useApi
            // const { data, error, metrics } = await sendAldRequestAxios({
            //     method: "POST",
            //     url: LANG_DETECTION_ENDPOINT_URL,
            //     headers: {
            //         "Authorization": apiKey,
            //         "Content-Type": "application/json"
            //     },
            //     body: requestBody,
            //     timeout: 30000,
            //     maxRetries: ALD_RETRY_ATTEMPTS,
            //     priority: "high",
            //     component: "SocketMicStreamer-ALD",
            //     abortable: true,
            //     isEncrypted: false,

            //     // Callbacks
            //     onStart: ({ requestId }) => {
            //         aldRequestIdRef.current = requestId;
            //         logInfo("ALD_START", `Starting language detection - Reason: ${reason}`, {
            //             requestId,
            //             attempt: aldRetryCountRef.current + 1,
            //             maxAttempts: ALD_RETRY_ATTEMPTS + 1
            //         });
            //     },

            //     onProgress: ({ message, elapsedTime, type }) => {
            //         logInfo("ALD_PROGRESS", message, {
            //             elapsedTime,
            //             type,
            //             audioLength: audioLengthSec.toFixed(2) + 's'
            //         });
            //     },

            //     onRetry: ({ attempt, maxRetries, retryDelay }) => {
            //         aldRetryCountRef.current = attempt;
            //         updateFlags({
            //             aldRetryCount: attempt,
            //             error: `ALD retry ${attempt}/${maxRetries}`
            //         });
            //         logInfo("ALD_RETRY", `Retrying language detection`, {
            //             attempt,
            //             maxRetries,
            //             retryDelay: `${retryDelay}ms`
            //         });
            //     },

            //     onSuccess: (responseData, responseMetrics) => {
            //         logInfo("ALD_SUCCESS", "Language detection API call successful", {
            //             duration: responseMetrics.duration,
            //             attempts: responseMetrics.attempts
            //         });
            //     },

            //     onError: (err, errorMetrics) => {
            //         logInfo("ALD_ERROR", `API call failed: ${err.message}`, {
            //             status: errorMetrics.status,
            //             duration: errorMetrics.duration,
            //             attempts: errorMetrics.attempts
            //         });
            //     },

            //     onComplete: ({ requestId }) => {
            //         aldRequestIdRef.current = null;
            //         logInfo("ALD_COMPLETE", "Request completed", { requestId });
            //     }
            // });
            const { data, error, metrics } = await sendAldRequestAxios({
                requestBody,
                apiKey,
                reason,
                audioLengthSec,
                startTime
            });
            // Handle response error
            if (error) {
                throw new Error(`ALD API error: ${error.message}`);
            }

            logInfo("ALD_METRICS", "Metrics from response", metrics);

            const langPrediction = data?.pipelineResponse?.[0]?.output?.[0]?.langPrediction?.[0];
            const detectedLang = langPrediction?.langCode;
            // langScore is sometimes null per Bhashini API — only reject when we have a score AND it's too low
            const langScore = langPrediction?.langScore ?? null;

            if (!detectedLang || typeof detectedLang !== "string" || detectedLang.includes("error")) {
                logInfo("ALD_DETECTION_ERROR", "Invalid language code in response", detectedLang);
                throw new Error(
                    detectedLang && detectedLang.includes("error")
                        ? detectedLang
                        : "No language detected in API response"
                );
            }

            if (!detectedLang) {
                throw new Error("No language detected in API response");
            }

            // Confidence gate: reject low-confidence detections so ALD retries with more audio
            // Skip this check when langScore is null (Bhashini often returns null for this field)
            if (langScore !== null && langScore < 0.6) {
                logInfo("ALD_LOW_CONFIDENCE", `Detected ${detectedLang} but score too low (${langScore.toFixed(3)}) — retrying`);
                throw new Error(`Low confidence language detection: ${detectedLang} (score: ${langScore.toFixed(3)})`);
            }

            setLanguage(detectedLang);
            console.log(`[ALD] Detected Language: ${detectedLang} | Confidence Score: ${langScore !== null ? langScore.toFixed(3) : "N/A (null)"}`);

            const processingTime = Date.now() - startTime;

            // dispatch(setSelectedSocketLanguageData({ code: detectedLang }));
            setSelectedSocketLanguageData({ code: detectedLang });
            hasDetectedLanguageRef.current = true;
            aldRetryCountRef.current = 0;

            updateFlags({
                detectingLanguage: false,
                languageDetected: true,
                detectedLanguage: detectedLang,
                aldProcessingTime: processingTime,
                processing: false,
                aldRetryCount: 0
            });


            const socketPromise = initiateSocket(detectedLang);
            socketPromise.catch(error => {
                logInfo("SOCKET_INIT_ERROR_FROM_ALD", error.message);
            });

            return detectedLang;

        } catch (error) {
            const processingTime = Date.now() - startTime;
            aldRetryCountRef.current++;

            logInfo("ALD_ERROR", `Attempt ${aldRetryCountRef.current} failed: ${error.message}`);

            if (aldRetryCountRef.current <= ALD_RETRY_ATTEMPTS &&
                getIsSocketRecording &&
                !error.message.includes('Audio quality insufficient')) {

                updateFlags({
                    detectingLanguage: false,
                    processing: false,
                    aldRetryCount: aldRetryCountRef.current,
                    error: `ALD retry ${aldRetryCountRef.current}/${ALD_RETRY_ATTEMPTS}: ${error.message}`
                });

                aldInProgressRef.current = false;

                setTimeout(async () => {
                    if (getIsSocketRecording && !hasDetectedLanguageRef.current && aldAudioBufferRef.current.length > 0) {
                        logInfo("ALD_RETRY", `Retrying language detection (${aldRetryCountRef.current}/${ALD_RETRY_ATTEMPTS})`);
                        await detectLanguage([...aldAudioBufferRef.current], `${reason}_RETRY_${aldRetryCountRef.current}`);
                    }
                }, 500);

                return "en";
            }

            updateFlags({
                detectingLanguage: false,
                error: `Language detection failed after ${aldRetryCountRef.current} attempts: ${error.message}`,
                processing: false,
                aldProcessingTime: processingTime,
                aldRetryCount: aldRetryCountRef.current
            });

            logInfo("ALD_FINAL_ERROR", `All attempts failed: ${error.message}`);


            // dispatch(setSelectedSocketLanguageData({ code: "en" }));
            setSelectedSocketLanguageData({ code: "en" });
            hasDetectedLanguageRef.current = true;
            aldRetryCountRef.current = 0;

            initiateSocket("en").catch(socketError => {
                logInfo("FALLBACK_SOCKET_ERROR", socketError.message);
            });

            return "en";

        } finally {
            aldInProgressRef.current = false;
        }
    };

    const decodeUnicodeText = (text) => {
        if (!text) return text;

        try {
            // Handle <0xXX> format - UTF-8 byte sequences displayed as hex
            // This regex finds sequences of <0xXX> bytes and converts them to proper characters
            let decoded = text.replace(/(<0x[0-9a-fA-F]{2}>)+/g, (match) => {
                try {
                    // Extract all hex bytes from the match
                    const hexBytes = match.match(/<0x([0-9a-fA-F]{2})>/g);
                    if (!hexBytes) return match;

                    // Convert hex strings to byte array
                    const bytes = hexBytes.map(hex => {
                        const byteValue = hex.replace(/<0x|>/g, '');
                        return parseInt(byteValue, 16);
                    });

                    // Decode UTF-8 bytes to string
                    const uint8Array = new Uint8Array(bytes);
                    const decodedStr = new TextDecoder('utf-8').decode(uint8Array);
                    return decodedStr;
                } catch (e) {
                    return match; // Return original if decoding fails
                }
            });

            // Handle \uXXXX format
            decoded = decoded.replace(/\\u([0-9a-fA-F]{4})/g, (_, hex) =>
                String.fromCharCode(parseInt(hex, 16))
            );

            // Handle \\uXXXX format (double escaped)
            decoded = decoded.replace(/\\\\u([0-9a-fA-F]{4})/g, (_, hex) =>
                String.fromCharCode(parseInt(hex, 16))
            );

            // Handle \xXX format
            decoded = decoded.replace(/\\x([0-9a-fA-F]{2})/g, (_, hex) =>
                String.fromCharCode(parseInt(hex, 16))
            );

            return decoded;
        } catch (e) {
            console.error("Error decoding Unicode text:", e);
            return text;
        }
    };

    const initiateSocket = async (languageCode) => {
        if (isSocketInitializingRef.current && socketInitPromiseRef.current) {
            logInfo('SOCKET_REUSE', `Reusing existing socket initialization for language: ${languageCode}`);
            return socketInitPromiseRef.current;
        }

        isSocketInitializingRef.current = true;

        socketInitPromiseRef.current = new Promise((resolve, reject) => {
            try {
                updateFlags({ socketConnecting: true, error: null });

                if (socketRef.current?.connected) {
                    socketRef.current.disconnect();
                }

                const socket = io(serverUrl, {
                    path: socketType === "asr" ? "/socket_vad_asr.io" : "/socket.io",
                    transports: ["websocket", "polling"],
                    reconnectionDelayMax: BROWSER_SETTINGS.socket.reconnectionDelayMax,
                    auth: { authorization: apiKey },
                    reconnectionAttempts: BROWSER_SETTINGS.socket.reconnectionAttempts,
                    timeout: BROWSER_SETTINGS.socket.timeout,
                    forceNew: true
                });

                socketRef.current = socket;

                socket.on("connect", () => {
                    logInfo("SOCKET", "Connected successfully");
                    updateFlags({ socketConnecting: false, error: null });
                    configurePipeline(languageCode);
                });

                socket.on("ready", () => {
                    logInfo("SOCKET", "Ready for audio streaming");
                    isSocketReadyRef.current = true;
                    updateFlags({ socketReady: true });

                    const audioToProcess = [...audioChunksRef.current, ...postAldAudioBufferRef.current];
                    if (audioToProcess.length > 0) {

                        postAldAudioBufferRef.current = [];
                        audioChunksRef.current = [];
                        audioChunksRef.current = [...audioToProcess];
                    }

                    setupAudioSending();
                    resolve(socket);
                });


                socket.on("response", (data, metadata) => {



                    const transcript = data?.pipelineResponse?.[0]?.output?.[0]?.source?.trim();
                    const decodedTranscript = decodeUnicodeText(transcript);
                    console.log("Received Transcript:", decodedTranscript);
                    if (!transcript) return;

                    const isInterim = metadata?.isIntermediateResult === true;

                    if (isInterim) {
                        // dispatch(setCurrentInterimTranscript(transcript));
                        setCurrentInterimTranscript(decodedTranscript);
                        // dispatch(setTranscriptType("interim"));
                        setTranscriptType("interim");
                        // dispatch(updateFlowStates());
                        // updateFlowStates();
                    } else {

                        if (decodedTranscript === lastFinalTranscriptRef.current) {
                            console.log('🚫 Skipping duplicate FINAL transcript');
                            return;
                        }


                        lastFinalTranscriptRef.current = decodedTranscript;


                        const currentAccumulated = accumulatedTranscriptRef.current || "";
                        const newAccumulated = currentAccumulated
                            ? `${currentAccumulated} ${decodedTranscript}`
                            : decodedTranscript;

                        // Update both refs
                        accumulatedTranscriptRef.current = newAccumulated;

                        // dispatch(setAccumulatedFinalTranscript(newAccumulated));
                        setAccumulatedFinalTranscript(newAccumulated);
                        // dispatch(setCurrentInterimTranscript(""));
                        setCurrentInterimTranscript("");
                        // dispatch(setTranscriptType("final"));
                        setTranscriptType("final");
                        // dispatch(updateFlowStates());
                        // updateFlowStates();

                        setTimeout(() => {
                            if (!isUserSpeaking.current) {
                                logInfo("AUTO_STOP", "Stopping after final transcription");
                                // setStreamingFlag(true);
                                stopStreaming();
                            }
                        }, 3000);
                    }
                });


                socket.on("disconnect", () => {
                    updateFlags({ socketReady: false, streaming: false });
                    isSocketReadyRef.current = false;
                });

                socket.on("connect_error", (err) => {
                    setIsSocketError(true);
                    updateFlags({
                        socketConnecting: false,
                        error: `Socket connection failed: ${err.message}`
                    });
                    logInfo("SOCKET_ERROR", err.message, err);
                    reject(err);
                });

                socket.on("error", (err) => {
                    logInfo("SOCKET_RUNTIME_ERROR", err.message, err);
                    updateFlags({ error: `Socket error: ${err.message}` });
                    reject(err);
                });

                setTimeout(() => {
                    if (!isSocketReadyRef.current) {
                        const error = new Error("Socket connection timeout after 10s");
                        logInfo("SOCKET_TIMEOUT", error.message);
                        reject(error);
                    }
                }, 10000);

            } catch (error) {
                updateFlags({
                    socketConnecting: false,
                    error: `Socket setup failed: ${error.message}`
                });
                logInfo("SOCKET_SETUP_ERROR", error.message, error);
                reject(error);
            }
        });

        try {
            const result = await socketInitPromiseRef.current;
            logInfo("SOCKET_SUCCESS", "Socket initiated successfully");
            return result;
        } finally {
            isSocketInitializingRef.current = false;
            socketInitPromiseRef.current = null;
        }
    };

    const configurePipeline = (lang = "en") => {
        try {
            const payload = [{
                taskType: "asr",
                config: {
                    language: { sourceLanguage: lang },
                    samplingRate: SAMPLE_RATE,
                    // disfluency_removal: strips filler words (um, uh, hmm) for cleaner output
                    // punctuation: adds commas, full-stops, question marks naturally
                    // itn: Inverse Text Normalization (numbers, dates in natural form)
                    postProcessors: ["punctuation", "itn", "disfluency_removal"],
                    audioFormat: "pcm",
                    encoding: "linear16",
                    modelType: "latest",
                    // Explicit punctuation flag — required by some Bhashini ASR model variants
                    enablePunctuation: true,
                    enableDisfluencyRemoval: true,
                }
            }, {
                // 0.8s gives model more context per chunk → more natural, complete phrases
                // (was 0.3s which caused choppy, screen-reader-like partial outputs)
                responseFrequencyInSecs: 0.8,
                responseTaskSequenceDepth: 1,
            }];

            socketRef.current?.emit("start", payload);
            updateFlags({ streaming: true });
            logInfo("PIPELINE", `Configured for language: ${lang}`, payload);
        } catch (error) {
            logInfo("PIPELINE_ERROR", error.message);
            updateFlags({ error: `Pipeline configuration failed: ${error.message}` });
        }
    };

    const setupAudioSending = () => {
        if (sendIntervalRef.current) return;

        sendIntervalRef.current = setInterval(async () => {
            try {
                if (!audioChunksRef.current.length ||
                    !isSocketReadyRef.current ||
                    isProcessingFinalAudioRef.current ||
                    !socketRef.current?.connected) {
                    return;
                }

                const chunksToSend = [...audioChunksRef.current];
                audioChunksRef.current = [];

                if (chunksToSend.length === 0) return;

                const totalLength = chunksToSend.reduce((acc, chunk) => acc + chunk?.length || 0, 0);
                if (totalLength === 0) return;

                const combined = new Float32Array(totalLength);
                let offset = 0;

                for (const chunk of chunksToSend) {
                    if (chunk && chunk.length) {
                        combined.set(chunk, offset);
                        offset += chunk.length;
                    }
                }

                const pcmData = convertAudioData(combined);
                if (!pcmData.length) return;

                socketRef.current.emit(
                    "data",
                    { audio: [{ audioContent: pcmData }] },
                    { responseTaskSequenceDepth: 1 },
                    false,
                    false
                );

            } catch (error) {
                logInfo("AUDIO_SEND_ERROR", error.message);
                updateFlags({ error: `Audio sending failed: ${error.message}` });
            }
        }, 50);
    };

    const handleSilenceDetected = async () => {

        if (isProcessingFinalAudioRef.current) return;

        isProcessingFinalAudioRef.current = true;
        isSilenceProcessingRef.current = true;

        try {
            logInfo("SILENCE", "Processing final audio after silence detection");

            clearInterval(sendIntervalRef.current);
            sendIntervalRef.current = null;

            if (!hasDetectedLanguageRef.current && !isLanguageExist() && aldAudioBufferRef.current.length > 0) {
                const totalSamples = aldAudioBufferRef.current.reduce((acc, chunk) => acc + chunk.length, 0);
                const duration = totalSamples / SAMPLE_RATE;

                // Match the same 1.5s minimum used in the main ALD quality gate
                if (duration >= 1.5) {
                    logInfo("SILENCE_ALD", `Processing ${duration.toFixed(2)}s of audio for final ALD`);
                    await detectLanguage([...aldAudioBufferRef.current], "SILENCE_FINAL_ALD");
                } else {
                    logInfo("SILENCE_ALD_SKIP", `Audio too short for ALD: ${duration.toFixed(2)}s, using fallback`);
                    // dispatch(setSelectedSocketLanguageData({ code: "en" }));
                    setSelectedSocketLanguageData({ code: "en" });
                    hasDetectedLanguageRef.current = true;
                    await initiateSocket("en");
                }
            }

            if (socketRef.current?.connected && audioChunksRef.current.length > 0) {
                const remainingChunks = [...audioChunksRef.current];
                const totalLength = remainingChunks.reduce((acc, chunk) => acc + chunk?.length || 0, 0);

                if (totalLength > 0) {
                    const combined = new Float32Array(totalLength);
                    let offset = 0;

                    for (const chunk of remainingChunks) {
                        if (chunk && chunk.length) {
                            combined.set(chunk, offset);
                            offset += chunk.length;
                        }
                    }

                    const pcmData = convertAudioData(combined);
                    if (pcmData.length > 0) {
                        socketRef.current.emit(
                            "data",
                            { audio: [{ audioContent: pcmData }] },
                            { responseTaskSequenceDepth: 1 },
                            false,
                            true
                        );
                    }
                }

                setTimeout(() => {
                    if (socketRef.current?.connected) {
                        socketRef.current.emit("end");
                        logInfo("SILENCE", "Sent end signal to socket");
                    }
                }, 100);
            }

            gracePeriodTimeoutRef.current = setTimeout(() => {
                logInfo("SILENCE", "Grace period ended, stopping streaming");
                // streamingended(true);
                stopStreaming();
            }, POST_SILENCE_GRACE_PERIOD);

        } catch (error) {
            logInfo("SILENCE_ERROR", error.message);
            stopStreaming();
        }
    };

    // const handleSilenceDetected = async () => {
    //     // 🔒 Prevent duplicate silence handling
    //     if (isSilenceProcessingRef.current) return;
    //     isSilenceProcessingRef.current = true;

    //     logInfo("SILENCE", "Silence detected, starting auto-stop timer");

    //     // 🔥 HARD STOP after 3 seconds of silence
    //     clearTimeout(gracePeriodTimeoutRef.current);
    //     gracePeriodTimeoutRef.current = setTimeout(() => {
    //         if (!isUserSpeaking.current) {
    //             logInfo("AUTO_STOP", "Stopping after 3s silence");
    //             setStreamingFlag(true);
    //             stopStreaming();
    //         }
    //     }, 3000);

    //     try {
    //         // Stop sending live chunks
    //         clearInterval(sendIntervalRef.current);
    //         sendIntervalRef.current = null;

    //         // ⚠️ ALD must NOT block silence stop
    //         if (
    //             !hasDetectedLanguageRef.current &&
    //             !isLanguageExist() &&
    //             aldAudioBufferRef.current.length > 0
    //         ) {
    //             detectLanguage([...aldAudioBufferRef.current], "SILENCE_FINAL_ALD")
    //                 .catch(err => logInfo("SILENCE_ALD_ERROR", err.message));
    //         }

    //         // Flush remaining audio to socket
    //         if (socketRef.current?.connected && audioChunksRef.current.length > 0) {
    //             const remainingChunks = [...audioChunksRef.current];
    //             audioChunksRef.current = [];

    //             const totalLength = remainingChunks.reduce((a, b) => a + b.length, 0);
    //             if (totalLength > 0) {
    //                 const combined = new Float32Array(totalLength);
    //                 let offset = 0;
    //                 for (const chunk of remainingChunks) {
    //                     combined.set(chunk, offset);
    //                     offset += chunk.length;
    //                 }

    //                 const pcmData = convertAudioData(combined);
    //                 if (pcmData.length) {
    //                     socketRef.current.emit(
    //                         "data",
    //                         { audio: [{ audioContent: pcmData }] },
    //                         { responseTaskSequenceDepth: 1 },
    //                         false,
    //                         true
    //                     );
    //                 }
    //             }

    //             setTimeout(() => {
    //                 socketRef.current?.emit("end");
    //                 logInfo("SILENCE", "End signal sent");
    //             }, 100);
    //         }

    //     } catch (err) {
    //         logInfo("SILENCE_ERROR", err.message);
    //     }
    // };


    const getSafariCompatibleVADOptions = () => {
        const baseOptions = getDefaultRealTimeVADOptions("v5");

        // if (BROWSER_TYPE === 'safari') {
        //     return {
        //         ...baseOptions,
        //         workletURL: null,
        //         modelURL: "https://cdn.jsdelivr.net/npm/@ricky0123/vad-web@0.0.7/dist/silero_vad.onnx",
        //         positiveSpeechThreshold: 0.8,
        //         negativeSpeechThreshold: 0.5,
        //     };
        // } else {
        //     return {
        //         ...baseOptions,
        //         modelURL: "/models/silero_vad_v5.onnx",
        //         workletURL: null,
        //     }
        // }
        if (BROWSER_TYPE === 'safari') {
            return {
                ...baseOptions,
                workletURL: VAD_WORKLET_URL,
                modelURL: VAD_MODEL_URL,
                positiveSpeechThreshold: 0.8,
                negativeSpeechThreshold: 0.5,
            };
        } else {
            return {
                ...baseOptions,
                modelURL: VAD_MODEL_URL,
                workletURL: VAD_WORKLET_URL,
            }
        }

        // return baseOptions;
    };

    const vad = useMicVAD({
        ...getSafariCompatibleVADOptions(),
        startOnLoad: false,
        // workletURL: undefined,
        // modelURL: undefined,
        userSpeakingThreshold: BROWSER_SETTINGS.vad.userSpeakingThreshold,
        redemptionFrames: 15,
        frameSamples: 512,
        onSpeechStart: () => {

            isUserSpeaking.current = true;
            speechStartTimeRef.current = Date.now();
            continuousSpeechDurationRef.current = 0;

            clearTimeout(silenceTimeoutRef.current);
            if (!isSilenceProcessingRef.current) {
                clearTimeout(gracePeriodTimeoutRef.current);
            }

            updateFlags({ listening: true, bufferStatus: 'collecting' });

            // dispatch(setIsSocketRecording(true));
            setIsSocketRecording(true);
        },
        onSpeechEnd: () => {
            isUserSpeaking.current = false;
            const speechDuration = speechStartTimeRef.current ?
                (Date.now() - speechStartTimeRef.current) : 0;


            // const silenceTimeout = speechDuration > 3000
            //     ? SILENCE_TIMEOUT
            //     : Math.max(SILENCE_TIMEOUT, 3000); // Changed from SILENCE_TIMEOUT / 2 to full timeout, minimum 3s
            const silenceTimeout = SILENCE_TIMEOUT_MS;

            silenceTimeoutRef.current = setTimeout(async () => {
                if (!isUserSpeaking.current && !isProcessingFinalAudioRef.current) {
                    logInfo("SILENCE", `Confirmed silence after ${(speechDuration / 1000).toFixed(2)}s speech`);
                    await handleSilenceDetected();
                }
            }, silenceTimeout);
        },
        onVADMisfire: () => {
            logInfo("VAD", "Misfire detected - validating before stopping");

            // Don't stop if we have active transcription or recent audio
            const hasRecentTranscript = currentInterimTranscript.length > 0 ||
                accumulatedFinalTranscript.length > 0;
            const hasRecentAudio = audioChunksRef.current.length > 0;
            const isSpeechActive = isUserSpeaking.current;

            if (!hasRecentTranscript && !hasRecentAudio && !isSpeechActive) {
                logInfo("VAD", "Confirmed misfire - stopping");
                stopStreaming();
            } else {
                logInfo("VAD", "False misfire - user still speaking, continuing recording");
            }
        },
        onFrameProcessed: (_, frame) => {
            if (frame && frame.length > 0) {
                // intentionally no-op
            }
        },
        onError: (error) => {
            logInfo("VAD_ERROR", `VAD failed: ${error.message}`);
            // Don't auto-stop on VAD errors
            updateFlags({
                error: `Voice detection error: ${error.message}`,
                listening: false
            });
        },
    });

    const resampleAudio = (audioData, originalSampleRate, targetSampleRate) => {
        if (originalSampleRate === targetSampleRate) {
            return audioData;
        }

        const ratio = originalSampleRate / targetSampleRate;
        const newLength = Math.round(audioData.length / ratio);
        const result = new Float32Array(newLength);

        for (let i = 0; i < newLength; i++) {
            const index = i * ratio;
            const indexFloor = Math.floor(index);
            const indexCeil = Math.min(Math.ceil(index), audioData.length - 1);
            const fraction = index - indexFloor;

            if (indexCeil === indexFloor) {
                result[i] = audioData[indexFloor];
            } else {
                result[i] = audioData[indexFloor] * (1 - fraction) + audioData[indexCeil] * fraction;
            }
        }

        return result;
    };

    const startStreaming = async () => {
        if (getIsSocketRecording) {
            logInfo("START_STREAMING", "Already recording, ignoring start request");
            return;
        }
        hasPushedCurrentTextRef.current = false;

        // dispatch(setIsMicButtonClicked(true));
        setIsMicButtonClicked(true);

        try {

            if (BROWSER_TYPE === 'safari' && !audioContextRef.current) {
                audioContextRef.current = new AudioContext({
                    latencyHint: BROWSER_SETTINGS.audioContext.latencyHint,
                });

                // Force resume immediately
                if (audioContextRef.current.state === 'suspended') {
                    await audioContextRef.current.resume();
                    logInfo("SAFARI_AUDIO", "AudioContext resumed after user gesture");
                }
            }

            setIsLoading(true);

            accumulatedTranscriptRef.current = "";
            lastFinalTranscriptRef.current = "";

            // dispatch(setDisplayTranscript(""));
            setDisplayTranscript("");
            // dispatch(setAccumulatedFinalTranscript(""));
            setAccumulatedFinalTranscript("");
            // dispatch(setCurrentInterimTranscript(""));
            setCurrentInterimTranscript("");
            // dispatch(setTranscriptType(""));
            setTranscriptType("");

            updateFlags({
                initializing: true,
                error: null,
                languageDetected: isLanguageExist(),
                audioLength: 0,
                aldProcessingTime: 0,
                audioQuality: 'unknown',
                bufferStatus: 'initializing',
                aldRetryCount: 0
            });

            logInfo("START_STREAMING", "Initializing audio streaming");

            // Reset all buffers and state
            audioChunksRef.current = [];
            aldAudioBufferRef.current = [];
            audioQualityBufferRef.current = [];
            postAldAudioBufferRef.current = [];
            completeAudioBufferRef.current = [];
            isSocketReadyRef.current = false;
            totalAudioDurationRef.current = 0;
            isProcessingFinalAudioRef.current = false;
            continuousSpeechDurationRef.current = 0;

            if (!isLanguageExist()) {
                aldInProgressRef.current = false;
                hasDetectedLanguageRef.current = false;
                aldRetryCountRef.current = 0;
                lastALDAttemptRef.current = 0;
            }

            const languageToUse = getLanguageCode();
            logInfo("START_STREAMING", `Using language: ${languageToUse} (predefined: ${isLanguageExist()})`);

            if (isLanguageExist()) {
                updateFlags({
                    detectingLanguage: false,
                    languageDetected: true,
                    detectedLanguage: languageToUse,
                    bufferStatus: 'ready'
                });
                await initiateSocket(languageToUse);
            } else {
                updateFlags({ bufferStatus: 'awaiting_language' });
            }

            let stream;
            try {
                const audioConstraints = {
                    channelCount: BROWSER_SETTINGS.audio.channelCount,
                    echoCancellation: BROWSER_SETTINGS.audio.echoCancellation,
                    noiseSuppression: BROWSER_SETTINGS.audio.noiseSuppression,
                    autoGainControl: BROWSER_SETTINGS.audio.autoGainControl,
                    latency: BROWSER_SETTINGS.audio.latency,
                    volume: BROWSER_SETTINGS.audio.volume
                };

                if (BROWSER_TYPE === 'safari') {
                    // Safari doesn't like some constraints - keep it simple
                    stream = await navigator.mediaDevices.getUserMedia({
                        audio: {
                            echoCancellation: true,
                            noiseSuppression: true,
                            autoGainControl: true,
                        }
                    });
                    logInfo("SAFARI_AUDIO", "Using simplified audio constraints for Safari");
                } else if (BROWSER_TYPE === 'firefox') {
                    // Firefox-specific code...
                    Object.assign(audioConstraints, {
                        mozEchoCancellation: BROWSER_SETTINGS.audio.mozEchoCancellation,
                        mozNoiseSuppression: BROWSER_SETTINGS.audio.mozNoiseSuppression,
                        mozAutoGainControl: BROWSER_SETTINGS.audio.mozAutoGainControl
                    });
                    stream = await navigator.mediaDevices.getUserMedia({
                        audio: audioConstraints
                    });
                } else {
                    audioConstraints.sampleRate = { ideal: SAMPLE_RATE };
                    stream = await navigator.mediaDevices.getUserMedia({
                        audio: audioConstraints
                    });
                }

            } catch (err) {

                logInfo("AUDIO_SETUP_ERROR", `getUserMedia failed: ${err.name} - ${err.message}`, { err });

                // Better error handling
                if (err.name === 'NotAllowedError' || err.name === 'PermissionDeniedError') {
                    updateFlags({
                        error: 'Microphone permission denied. Please allow access in browser settings.',
                        initializing: false,
                        browserCompatible: false
                    });
                    setIsLoading(false);
                    return;
                }

                // Fallback...
                logInfo("AUDIO_SETUP_WARNING", `Failed to get media with constraints, trying fallback: ${err.message}`);
                try {
                    stream = await navigator.mediaDevices.getUserMedia({ audio: true });
                } catch (fallbackErr) {
                    updateFlags({
                        error: `Microphone access failed: ${fallbackErr.message}`,
                        initializing: false
                    });
                    setIsLoading(false);
                    return;
                }
            }

            mediaStreamRef.current = stream;

            const audioTrack = stream.getAudioTracks()[0];
            const streamSettings = audioTrack.getSettings();
            const actualSampleRate = streamSettings.sampleRate || 48000;

            logInfo("AUDIO_SETUP", `Stream sample rate: ${actualSampleRate}Hz, Browser: ${BROWSER_TYPE}`);

            let audioContextSampleRate = actualSampleRate;
            if (BROWSER_TYPE === 'safari') {
                // ✅ Safari: ALWAYS use native sample rate
                audioContextRef.current = new AudioContext({
                    latencyHint: BROWSER_SETTINGS.audioContext.latencyHint,
                    // DO NOT set sampleRate - let Safari use its default
                });
                audioContextSampleRate = audioContextRef.current.sampleRate; // Usually 44100 or 48000
                logInfo("SAFARI_AUDIO", `Using native sample rate: ${audioContextSampleRate}Hz`);

            } else if (BROWSER_TYPE !== 'firefox') {
                try {
                    audioContextRef.current = new AudioContext({
                        sampleRate: SAMPLE_RATE,
                        latencyHint: BROWSER_SETTINGS.audioContext.latencyHint,
                    });
                } catch (err) {
                    logInfo("AUDIO_CONTEXT_WARNING", `Failed to create AudioContext with sample rate ${SAMPLE_RATE}: ${err.message}`);
                    audioContextRef.current = new AudioContext({
                        sampleRate: actualSampleRate,
                        latencyHint: BROWSER_SETTINGS.audioContext.latencyHint,
                    });
                }
            } else {
                audioContextRef.current = new AudioContext({
                    sampleRate: actualSampleRate,
                    latencyHint: BROWSER_SETTINGS.audioContext.latencyHint,
                });
            }

            if (audioContextRef.current.state === 'suspended') {
                await audioContextRef.current.resume();
            }

            const sourceNode = audioContextRef.current.createMediaStreamSource(stream);
            const processorNode = audioContextRef.current.createScriptProcessor(
                BROWSER_SETTINGS.scriptProcessor.bufferSize,
                BROWSER_SETTINGS.scriptProcessor.inputChannels,
                BROWSER_SETTINGS.scriptProcessor.outputChannels
            );

            processorNode.onaudioprocess = async (e) => {
                try {
                    if (isProcessingFinalAudioRef.current || !e.inputBuffer) return;

                    const inputData = e.inputBuffer.getChannelData(0);
                    if (!inputData || inputData.length === 0) return;

                    const chunkCopy = new Float32Array(inputData.length);
                    for (let i = 0; i < inputData.length; i++) {
                        chunkCopy[i] = inputData[i];
                    }

                    const originalSampleRate = audioContextRef.current.sampleRate;
                    const processedChunk = resampleAudio(chunkCopy, originalSampleRate, SAMPLE_RATE);

                    const chunkRMS = Math.sqrt(processedChunk.reduce((sum, sample) => sum + sample * sample, 0) / processedChunk.length);
                    const NOW = Date.now();

                    if (chunkRMS > 0.0075) {

                        lastSoundTimeRef.current = NOW;
                        silenceDeadlineRef.current = null;

                        // 🔥 cancel silence timer immediately
                        if (silenceTimerRef.current) {
                            clearTimeout(silenceTimerRef.current);
                            silenceTimerRef.current = null;
                        }

                        completeAudioBufferRef.current.push(processedChunk);
                        if (hasDetectedLanguageRef.current && isSocketReadyRef.current) {
                            audioChunksRef.current.push(processedChunk);
                        } else if (hasDetectedLanguageRef.current && !isSocketReadyRef.current) {
                            postAldAudioBufferRef.current.push(processedChunk);
                        } else {
                            aldAudioBufferRef.current.push(processedChunk);
                            if (aldInProgressRef.current) {
                                postAldAudioBufferRef.current.push(processedChunk);
                            } else {
                                audioChunksRef.current.push(processedChunk);
                            }
                        }

                        audioQualityBufferRef.current.push(chunkRMS);

                        if (aldAudioBufferRef.current.length * processedChunk.length > MAX_BUFFER_SIZE) {
                            aldAudioBufferRef.current = aldAudioBufferRef.current.slice(-Math.floor(MAX_BUFFER_SIZE / processedChunk.length));
                            logInfo("BUFFER_MANAGEMENT", "ALD buffer trimmed to prevent overflow");
                        }

                        totalAudioDurationRef.current += processedChunk.length / SAMPLE_RATE;
                        updateFlags({
                            audioLength: totalAudioDurationRef.current.toFixed(1),
                            bufferStatus: isLanguageExist() || hasDetectedLanguageRef.current ? 'streaming' : 'collecting'
                        });

                        if (!isLanguageExist() && !hasDetectedLanguageRef.current && !aldInProgressRef.current) {
                            const totalSamples = aldAudioBufferRef.current.reduce((acc, chunk) => acc + chunk.length, 0);
                            const currentDuration = totalSamples / SAMPLE_RATE;


                            const avgQuality = audioQualityBufferRef.current.reduce((sum, rms) => sum + rms, 0) / audioQualityBufferRef.current.length;
                            const hasGoodQuality = avgQuality > BROWSER_SETTINGS.quality.aldQualityThreshold;
                            const hasMinDuration = currentDuration >= 6;
                            const hasGoodEnoughQuality = avgQuality > (BROWSER_SETTINGS.quality.aldQualityThreshold * 0.7);
                            const hasSufficientSpeech = isUserSpeaking.current && continuousSpeechDurationRef.current > 1500;

                            if ((hasGoodQuality && hasMinDuration) ||
                                (hasGoodEnoughQuality && hasSufficientSpeech) ||
                                (currentDuration >= 6)) {

                                let reason;

                                if (hasMinDuration) {
                                    reason = `DURATION_${currentDuration.toFixed(1)}S`;
                                } else if (hasSufficientSpeech) {
                                    reason = `SPEECH_${(continuousSpeechDurationRef.current / 1000).toFixed(1)}S`;
                                } else {
                                    reason = `FORCE_${currentDuration.toFixed(1)}S`;
                                }


                                let audioForALD;
                                if (currentDuration > 6) {
                                    const samplesFor6Seconds = 6 * SAMPLE_RATE;
                                    let totalSamplesCollected = 0;
                                    const chunks6Seconds = [];

                                    for (let i = aldAudioBufferRef.current.length - 1; i >= 0; i--) {
                                        const chunk = aldAudioBufferRef.current[i];
                                        if (totalSamplesCollected + chunk.length <= samplesFor6Seconds) {
                                            chunks6Seconds.unshift(chunk);
                                            totalSamplesCollected += chunk.length;
                                        } else {
                                            const remainingSamples = samplesFor6Seconds - totalSamplesCollected;
                                            if (remainingSamples > 0) {
                                                const partialChunk = chunk.slice(-remainingSamples);
                                                chunks6Seconds.unshift(partialChunk);
                                            }
                                            break;
                                        }
                                    }
                                    audioForALD = chunks6Seconds;

                                } else {
                                    audioForALD = [...aldAudioBufferRef.current];
                                }

                                detectLanguage(audioForALD, reason)
                                    .catch(err => {
                                        logInfo("ALD_TRIGGER_ERROR", err.message);
                                    });
                            }
                        }
                    }
                    else {
                        if (!hasPushedCurrentTextRef.current) {
                            return; // ❗ wait until text is synced to parent
                        }

                        if (!silenceDeadlineRef.current) {
                            // silenceDeadlineRef.current = lastSoundTimeRef.current + 3000;
                            silenceDeadlineRef.current = lastSoundTimeRef.current + SILENCE_TIMEOUT_MS;

                        }

                        if (NOW >= silenceDeadlineRef.current && !isProcessingFinalAudioRef.current) {

                            logInfo("SILENCE", "Confirmed RMS silence (3s)");

                            hasPushedCurrentTextRef.current = false;
                            silenceDeadlineRef.current = null;

                            handleSilenceDetected();
                        }
                    }

                } catch (error) {
                    updateFlags({ error: `Audio processing error: ${error.message}` });
                    logInfo("AUDIO_PROCESS_ERROR", error.message, error);
                }
            };

            sourceNode.connect(processorNode);
            processorNode.connect(audioContextRef.current.destination);
            sourceNodeRef.current = sourceNode;
            processorNodeRef.current = processorNode;

            if (BROWSER_TYPE === 'safari') {
                await new Promise(resolve => setTimeout(resolve, 100));
                logInfo("SAFARI_AUDIO", "Delayed VAD start for Safari compatibility");
            }

            vad.start();

            updateFlags({
                initializing: false,
                bufferStatus: isLanguageExist() ? 'ready' : 'collecting'
            });
            // dispatch(setIsSocketRecording(true));
            setIsSocketRecording(true);
        } catch (err) {
            updateFlags({
                initializing: false,
                error: `Failed to start streaming: ${err.message}`,
                bufferStatus: 'error'
            });
            logInfo("STREAM_START_ERROR", err.message, err);
            await stopStreaming();
        } finally {
            setIsLoading(false);
        }
    };

    const getCompleteTranscript = () => {
        return accumulatedFinalTranscript +
            (accumulatedFinalTranscript && currentInterimTranscript ? " " : "") +
            currentInterimTranscript;
    };

    const stopStreaming = async () => {
        try {
            // dispatch(setIsMicButtonClicked(false));
            setIsMicButtonClicked(false);
            setSelectedSocketLanguageData(undefined);

            if (aldRequestIdRef.current) {
                logInfo("STOP_STREAMING", "Cancelling ongoing ALD request", {
                    requestId: aldRequestIdRef.current
                });
                // sharedApiService.cancelRequest(aldRequestIdRef.current);
                aldRequestIdRef.current = null;
            }

            clearTimeout(silenceTimeoutRef.current);
            clearTimeout(gracePeriodTimeoutRef.current);
            clearInterval(sendIntervalRef.current);
            accumulatedTranscriptRef.current = "";
            lastFinalTranscriptRef.current = "";

            // dispatch(setIsSocketRecording(false));
            setIsSocketRecording(false);
            sendIntervalRef.current = null;
            isSilenceProcessingRef.current = false;
            isProcessingFinalAudioRef.current = false;
            isUserSpeaking.current = false;
            isSocketInitializingRef.current = false;
            socketInitPromiseRef.current = null;

            try {
                vad.pause();
            } catch (vadError) {
                logInfo("VAD_STOP_ERROR", vadError.message);
            }

            try {
                if (processorNodeRef.current) {
                    processorNodeRef.current.disconnect();
                    processorNodeRef.current = null;
                }

                if (sourceNodeRef.current) {
                    sourceNodeRef.current.disconnect();
                    sourceNodeRef.current = null;
                }

                if (mediaStreamRef.current) {
                    mediaStreamRef.current.getTracks().forEach(track => {
                        track.stop();
                    });
                    mediaStreamRef.current = null;
                }

                if (audioContextRef.current && audioContextRef.current.state !== "closed") {
                    await audioContextRef.current.close();
                    audioContextRef.current = null;
                }
            } catch (audioError) {
                logInfo("AUDIO_CLEANUP_ERROR", audioError.message);
            }

            try {
                if (socketRef.current?.connected) {
                    socketRef.current.emit("end");
                    socketRef.current.disconnect();
                }
                socketRef.current = null;
                isSocketReadyRef.current = false;
            } catch (socketError) {
                logInfo("SOCKET_CLEANUP_ERROR", socketError.message);
            }

            if (completeAudioBufferRef.current.length > 0) {
                try {
                    const base64Audio = await getCombinedAudioBase64(completeAudioBufferRef.current);
                    if (base64Audio) {
                        // dispatch(setRecordedBase64Data(base64Audio));
                        setRecordedBase64Data(base64Audio);

                        // Send audio to parent component for speech2text processing
                        if (onAudioRecorded) {
                            console.log("📤 Sending audio to parent, length:", base64Audio.length);
                            onAudioRecorded(base64Audio);
                        } else {
                            console.warn("⚠️ onAudioRecorded callback not provided");
                        }

                        // dispatch(updateFlowStates());
                        // updateFlowStates();
                    }
                } catch (saveError) {
                    logInfo("AUDIO_SAVE_ERROR", `Failed to save recording: ${saveError.message}`);
                }
            } else {
                // dispatch(setRecordedBase64Data(null));
                setRecordedBase64Data(null);
                logInfo("AUDIO_SAVE_SKIP", "No audio data to save");
            }

        } catch (error) {
            logInfo("STOP_ERROR", error.message, error);
        } finally {
            audioChunksRef.current = [];
            aldAudioBufferRef.current = [];
            audioQualityBufferRef.current = [];
            postAldAudioBufferRef.current = [];
            completeAudioBufferRef.current = [];
            totalAudioDurationRef.current = 0;
            continuousSpeechDurationRef.current = 0;

            setIsSocketError(false);

            updateFlags({
                listening: false,
                streaming: false,
                socketReady: false,
                detectingLanguage: false,
                socketConnecting: false,
                processing: false,
                initializing: false,
                languageDetected: isLanguageExist(),
                audioLength: 0,
                aldProcessingTime: 0,
                audioQuality: 'unknown',
                bufferStatus: 'idle',
                aldRetryCount: 0,
                error: null
            });

        }
    };

    useImperativeHandle(ref, () => ({
        stopStreaming,
    }));

    useImperativeHandle(ref, () => ({
        startStreaming,
        stopStreaming,
        detectLanguage,
        initiateSocket,
        isLanguageExist,
        getLanguageCode,
        assessAudioQuality: () => assessAudioQuality(aldAudioBufferRef.current),
        getBufferStatus: () => ({
            aldBuffer: aldAudioBufferRef.current.length,
            audioBuffer: audioChunksRef.current.length,
            postAldBuffer: postAldAudioBufferRef.current.length,
            totalDuration: totalAudioDurationRef.current,
            hasLanguage: isLanguageExist(),
            languageDetected: hasDetectedLanguageRef.current
        }),
        forceLanguageDetection: async () => {
            if (aldAudioBufferRef.current.length > 0) {
                return await detectLanguage([...aldAudioBufferRef.current], "MANUAL_TRIGGER");
            }
            throw new Error("No audio buffer available for language detection");
        },
        getCompleteTranscript: () => getCompleteTranscript(),
        getAccumulatedFinal: () => accumulatedFinalTranscript,
        getCurrentInterim: () => currentInterimTranscript
    }));

    useEffect(() => {
        return () => {
            logInfo("COMPONENT_UNMOUNT", "Cleaning up component");
            stopStreaming();
        };
    }, []);

    useEffect(() => {
        const combined = accumulatedFinalTranscript +
            (accumulatedFinalTranscript && currentInterimTranscript ? " " : "") +
            currentInterimTranscript;
        // dispatch(setDisplayTranscript(combined));
        setDisplayTranscript(combined);
    }, [accumulatedFinalTranscript, currentInterimTranscript]);

    const getButtonState = () => {
        if (isSocketErr || flags.initializing) return 'disabled';
        if (flags.error) return 'error';
        if (flags.listening) return 'listening';
        if (flags.detectingLanguage) return 'detecting';
        if (flags.socketConnecting) return 'connecting';
        if (flags.processing) return 'processing';
        if (getIsSocketRecording) return 'recording';
        return 'idle';
    };

    const getButtonConfig = (state) => {
        const configs = {
            disabled: {
                className: "bg-gradient-to-br from-gray-400 to-gray-500 cursor-not-allowed opacity-60",
                icon: <Loader2 className="animate-spin w-8 h-8 text-white" />
            },
            error: {
                className: "bg-gradient-to-br from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 shadow-xl shadow-red-500/30",
                icon: <AlertCircle className="w-8 h-8 text-white animate-bounce" />
            },
            listening: {
                className: "bg-gradient-to-br from-emerald-500 to-green-600 hover:from-emerald-600 hover:to-green-700 shadow-xl shadow-emerald-500/30",
                icon: <div className="relative flex items-center justify-center">
                    <div className="relative w-8 h-8">
                        <div className="absolute inset-0 rounded-full bg-white/20 animate-ping"></div>
                        <div className="absolute inset-2 rounded-full bg-white animate-pulse"></div>
                        <div className="absolute inset-3 rounded-full bg-emerald-600"></div>
                    </div>
                </div>
            },
            detecting: {
                className: "bg-gradient-to-br from-violet-500 to-purple-600 hover:from-violet-600 hover:to-purple-700 shadow-xl shadow-violet-500/30",
                icon: <div className="relative">
                    <Globe className="w-8 h-8 text-white animate-pulse" />
                    <div className="absolute -inset-2 border border-white/40 rounded-full animate-spin" />
                </div>
            },
            connecting: {
                className: "bg-gradient-to-br from-amber-500 to-orange-600 hover:from-amber-600 hover:to-orange-700 shadow-xl shadow-amber-500/30",
                icon: <div className="flex flex-col items-center space-y-1">
                    <div className="flex space-x-1">
                        {[0, 200, 400].map((delay, idx) => (
                            <div
                                key={delay}
                                className="w-2 h-2 bg-white rounded-full animate-bounce"
                                style={{ animationDelay: `${delay}ms` }}
                            />
                        ))}
                    </div>
                    <div className="text-xs text-white/80 font-medium">SYNC</div>
                </div>
            },
            processing: {
                className: "bg-gradient-to-br from-cyan-500 to-blue-600 hover:from-cyan-600 hover:to-blue-700 shadow-xl shadow-cyan-500/30",
                icon: <div className="relative">
                    <Waves className="w-8 h-8 text-white" />
                    <div className="absolute inset-0">
                        <div className="absolute top-0 left-1/2 w-0.5 h-8 bg-white/60 animate-pulse transform -translate-x-0.5"></div>
                        <div className="absolute top-1/2 left-0 w-8 h-0.5 bg-white/60 animate-pulse transform -translate-y-0.5"></div>
                    </div>
                </div>
            },
            // recording: {
            //     className: "bg-gradient-to-br from-red-600 to-rose-700 hover:from-red-700 hover:to-rose-800 shadow-xl shadow-red-600/40 animate-pulse",
            //     icon: <div className="relative flex items-center justify-center">
            //         <div className="relative w-8 h-8">
            //             <div className="absolute inset-0 rounded-full bg-white/20 animate-ping"></div>
            //             <div className="absolute inset-2 rounded-full bg-white animate-pulse"></div>
            //             <div className="absolute inset-3 rounded-full bg-red-600"></div>
            //         </div>
            //     </div>
            // },
            recording: {
                // className: "bg-gradient-to-br from-red-600 to-rose-700 hover:from-red-700 hover:to-rose-800 shadow-xl shadow-red-600/40 animate-pulse",
                icon: <div className="relative flex items-center justify-center">
                    <div className="relative w-full h-full">
                        <img src={voiceAssistantGif} alt="recording" />
                    </div>
                </div>
            },
            idle: {
                className: "bg-gradient-to-br bg-white  border-[var(--main-btn-color-2)] border-8 hover:from-[#0A48AA] hover:to-[var(--main-btn-color-2)] ",
                icon: <Mic className={`w-8 h-8 sm:w-8 sm:h-8 ${isMicButtonDisabled ? "text-white" : "text-[#808080]"}  hover:text-white drop-shadow-lg`} />
            }
        };
        return configs[state];
    };

    const buttonState = getButtonState();
    const buttonConfig = getButtonConfig(buttonState);


    const getCircleFillPercentage = () => {
        if (hasDetectedLanguageRef.current || isLanguageExist() || !getIsSocketRecording) {
            return 0; // No fill after language detection or when not recording
        }

        const currentDuration = totalAudioDurationRef.current;
        const fillPercentage = Math.min((currentDuration / 6) * 100, 100);
        return fillPercentage;
    };

    const isMicDisabledUI = useMemo(() => {
        return (
            buttonState === 'disabled' ||
            isLanguageDetecting ||
            isNerDetecting ||
            isContentGenerating
        );
    }, [buttonState, isLanguageDetecting, isNerDetecting, isContentGenerating]);


    return (

        <>
            {isUserInputBar ? (
                <>
                    <div className="micbackground flex flex-col items-center justify-center space-y-4 w-[12vh] h-[12vh] sm:w-[12vh] sm:h-[12vh]">
                        <motion.div
                            animate={"active"}
                            transition={{ duration: 0.3, ease: "easeOut" }}
                            className="flex items-center justify-end relative"
                        >
                            <motion.button
                                whileHover={{ scale: isMicDisabledUI || isMicButtonDisabled ? 1 : 1.02 }}
                                whileTap={{ scale: isMicDisabledUI || isMicButtonDisabled ? 1 : 0.96 }}
                                onClick={getIsSocketRecording ? stopStreaming : startStreaming}
                                title="Mic"
                                disabled={isMicDisabledUI || isMicButtonDisabled}
                                className={`relative rounded-full flex items-center justify-center transition-all duration-300
                  ${buttonConfig.className} 
                  disabled:from-gray-400 disabled:to-gray-500 disabled:cursor-not-allowed
                  flex items-center justify-center w-[10vh] h-[10vh] relative overflow-hidden group`}
                            >
                                {/* Shine animation */}
                                <motion.div
                                    animate={{
                                        x: isMicDisabledUI || isMicButtonDisabled ? 0 : [-100, 100],
                                    }}
                                    transition={{
                                        duration: 2,
                                        repeat: isMicDisabledUI || isMicButtonDisabled ? 0 : Infinity,
                                        ease: "easeInOut",
                                    }}
                                    className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent skew-x-12 opacity-0 group-hover:opacity-100 rounded-full"
                                />

                                {/* Icon animation */}
                                <div className="flex items-center space-x-2 relative z-10">
                                    <motion.div
                                    // animate={
                                    //     isMicDisabledUI || isMicButtonDisabled
                                    //         ? { x: 0, rotate: 0 }
                                    //         : { x: [0, 3, 0], rotate: [0, 12, -6, 0] }
                                    // }
                                    // transition={{
                                    //     duration: 2.5,
                                    //     ease: "easeInOut",
                                    //     repeat: isMicDisabledUI || isMicButtonDisabled ? 0 : Infinity,
                                    // }}
                                    >
                                        {buttonConfig.icon}
                                    </motion.div>
                                </div>
                            </motion.button>
                        </motion.div>
                    </div>

                </>

            ) : (
                <div className="flex flex-col items-center space-y-6">

                    <div className="relative flex justify-center items-center mt-5 mb-2">
                        <motion.div
                            className={`absolute w-[140px] h-[140px] rounded-full border-2 transition-all duration-300 ${getIsSocketRecording ? ' bg-[var(--bg-color-2)] border border-[#E0E0E0]' : 'bg-[var(--bg-color-2)] border border-[#E0E0E0]'
                                }`}
                            animate={getIsSocketRecording ? { scale: [1, 1.05, 1] } : { scale: 1 }}
                            transition={{ duration: 2, repeat: getIsSocketRecording ? Infinity : 0 }}
                        />
                        <motion.div
                            className="absolute w-[115px] h-[115px] rounded-full shadow-lg bg-[var(--main-btn-color)]"
                            transition={{
                                duration: 1.5,
                                repeat: getIsSocketRecording ? Infinity : 0,
                                ease: "easeInOut"
                            }}
                        />

                        <motion.button
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                            onClick={getIsSocketRecording ? stopStreaming : startStreaming}
                            disabled={buttonState === 'disabled'}
                            className={`relative w-[90px] h-[90px] rounded-full bg-white shadow-xl flex justify-center items-center shadow-lg transition-all duration-300 ${buttonState === 'disabled' ? 'cursor-not-allowed opacity-60' : 'cursor-pointer hover:shadow-2xl'
                                }`}
                            style={{
                                boxShadow: getIsSocketRecording
                                    ? '0 20px 40px rgba(59, 130, 246, 0.3), 0 0 0 4px rgba(59, 130, 246, 0.1)'
                                    : '0 10px 25px rgba(0, 0, 0, 0.15)'
                            }}
                        >
                            {getIsSocketRecording ? (
                                <div className="flex flex-col items-center justify-center">
                                    <motion.div
                                        className="absolute w-[115px] h-[115px] rounded-full overflow-hidden"
                                        style={{
                                            background: `conic-gradient(from 0deg at 50% 50%, 
                                                #40FA84 0deg, 
                                                #40FA84 ${(getCircleFillPercentage() / 100) * 360}deg, 
                                                transparent ${(getCircleFillPercentage() / 100) * 360}deg, 
                                                transparent 360deg)`
                                        }}
                                        animate={{
                                            opacity: (getCircleFillPercentage() > 0 && !hasDetectedLanguageRef.current) ? 0.7 : 0
                                        }}
                                        transition={{ duration: 0.3 }}
                                    />
                                    <motion.div
                                        animate={{ scale: [1, 1.1, 1] }}
                                        transition={{ duration: 0.6, repeat: Infinity }}
                                    >
                                        <img src={voiceAssistantGif} alt="Recording" />
                                    </motion.div>
                                </div>
                            ) : (
                                <motion.div
                                    initial={{ scale: 0.9, opacity: 0 }}
                                    animate={{ scale: 1, opacity: 1 }}
                                    transition={{ duration: 0.3 }}
                                >
                                    {/* <img src={micIcon} className="" alt="Voice Assistant" /> */}
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="36"
                                        height="36"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="gray"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="lucide lucide-mic-icon lucide-mic">
                                        <path d="M12 19v3" />
                                        <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
                                        <rect x="9" y="2" width="6" height="13" rx="3" />
                                    </svg>
                                    <div className="flex gap-1 mt-2">
                                        {bars.map((bar, i) => (
                                            <motion.div
                                                key={`${bar.height}-${bar.delay}`}
                                                className={`w-1/2 bg-gray-500 rounded ${bar.height}`}
                                                animate={{
                                                    scaleY: [1, 1.8, 1],
                                                    opacity: [0.5, 1, 0.5],
                                                }}
                                                transition={{
                                                    duration: 0.8,
                                                    repeat: Infinity,
                                                    repeatType: "loop",
                                                    delay: bar.delay,
                                                }}
                                                style={{ transformOrigin: "bottom" }}
                                            />
                                        ))}
                                    </div>
                                </motion.div>
                            )}

                            {isLoading && (
                                <motion.div
                                    className="absolute inset-0 rounded-full bg-white/80 flex items-center justify-center"
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                >
                                    <Loader2 className="w-6 h-6 text-blue-500 animate-spin" />
                                </motion.div>
                            )}
                        </motion.button>

                        <TooltipBubble
                            show={getIsSocketRecording && isLanguageExist() && (currentInterimTranscript || accumulatedFinalTranscript)}
                            message={t("message")}
                            className="left-[95px] -top-4"
                            slideDistance={100}
                            animationDuration={1}
                            fadeDelay={0.2}
                            delayBeforeShow={3}
                        />

                        <AnimatePresence>
                            {buttonState !== 'idle' && buttonState !== 'recording' && (
                                <motion.div
                                    className="absolute -top-2 -right-2 w-[0px] h-[0px] rounded-full bg-white shadow-lg flex items-center justify-center"
                                    initial={{ scale: 0, opacity: 0 }}
                                    animate={{ scale: 1, opacity: 1 }}
                                    exit={{ scale: 0, opacity: 0 }}
                                >
                                    {buttonState === 'error' && <AlertCircle className="w-4 h-4 text-red-500" />}
                                    {buttonState === 'detecting' && <Globe className="w-4 h-4 text-violet-500 animate-pulse" />}
                                    {buttonState === 'connecting' && <Loader2 className="w-4 h-4 text-amber-500 animate-spin" />}
                                    {buttonState === 'processing' && <Waves className="w-4 h-4 text-cyan-500" />}
                                </motion.div>
                            )}
                        </AnimatePresence>
                    </div>

                    <AnimatePresence>
                        {getIsSocketRecording && (
                            <motion.div
                                key={`transcript-${transcriptType}`}
                                className={`w-[calc(100%-20px)] max-w-4xl rounded-md px-4 py-2 border shadow-lg mx-[10px] ${transcriptType === 'final'
                                    ? 'bg-gradient-to-br from-green-50 via-emerald-50 to-teal-100 border-green-200'
                                    : 'bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-100 border-blue-200'
                                    }`}
                                initial={{ opacity: 0, y: 20, scale: 0.95 }}
                                animate={{ opacity: 1, y: 0, scale: 1 }}
                                exit={{ opacity: 0, y: -10, scale: 0.95 }}
                                transition={{ duration: 0.3 }}
                            >
                                {(isLanguageExist()) && (
                                    <>
                                        <div className="flex items-center justify-center">
                                            <span className="text-sm text-gray-600 font-semibold">
                                                {t('detectedLanguageText')}:{" "}
                                                <span className="">
                                                    {`${getLanguageData(getLanguageCode()).label}`}
                                                </span>
                                            </span>
                                        </div>
                                        <motion.p
                                            className="text-sm text-gray-800 text-center mt-1 font-semibold"
                                            animate={{ opacity: [0.6, 1, 0.6] }}
                                            transition={{ duration: 1.5, repeat: Infinity }}
                                        >
                                            <span>🎤 {t('listeningKeepSpeak')} ({totalAudioDurationRef.current.toFixed(1)}s)</span>
                                        </motion.p>
                                    </>
                                )}
                                {getIsSocketRecording && !isLanguageExist() && (
                                    <div className="flex items-center justify-center">
                                        <span className="text-sm text-gray-600">
                                            <span className="font-semibold">
                                                {t('keepSpkLanguageDetection')}
                                            </span>
                                        </span>
                                    </div>
                                )}

                                {displayTranscript && (
                                    <div
                                        ref={transcriptRef}
                                        className="bg-white/70 backdrop-blur-sm rounded-xl p-4 border border-white/20 mt-3"
                                        style={{
                                            maxHeight: `${window.innerHeight - 470}px`,
                                            overflowY: "auto",
                                        }}
                                    >
                                        <motion.p
                                            className="text-gray-800 text-lg leading-relaxed font-medium text-center"
                                            animate={currentInterimTranscript ? { opacity: [0.8, 1, 0.8] } : { opacity: 1 }}
                                            transition={{ duration: 1.5, repeat: currentInterimTranscript ? Infinity : 0 }}
                                        >
                                            {/* Final transcript in bold */}
                                            {accumulatedFinalTranscript && (
                                                <span className="text-gray-900 font-semibold">
                                                    {accumulatedFinalTranscript}
                                                </span>
                                            )}

                                            {/* Space between final and interim */}
                                            {accumulatedFinalTranscript && currentInterimTranscript && " "}

                                            {/* Interim transcript with cursor */}
                                            {currentInterimTranscript && (
                                                <span className="text-gray-700 opacity-80">
                                                    {currentInterimTranscript}
                                                    <motion.span
                                                        className="inline-block w-1 h-5 bg-blue-600 ml-1 rounded"
                                                        animate={{ opacity: [0, 1, 0] }}
                                                        transition={{ duration: 1, repeat: Infinity }}
                                                    />
                                                </span>
                                            )}
                                        </motion.p>
                                    </div>
                                )}
                            </motion.div>
                        )}
                    </AnimatePresence>
                </div>
            )}
            <div style={{ display: "none" }}>{vad.ref}</div>
        </>
    );
});

SocketMicStreamer.propTypes = {
    isUserInputBar: PropTypes.bool,
};

SocketMicStreamer.displayName = "SocketMicStreamer";
export default SocketMicStreamer;